import moment from 'moment';

export default (date) => (date ? moment(date).utc().format('YYYY-MM-DD H:mm:ss') : '');
